//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapMutations } from "vuex";

export default {
  name: "SearchTags",
	props: {
		tags: Array,
		removeTag: Function,
		activeTagIds: Array,
	},
	computed: {
		...mapGetters([
			"results",
			"activeSearchTerm"
		]),
	},
	methods: {
		...mapMutations([
			"setStateValue"
		]),
		removeOne(tag) {
			this.removeTag(tag);
			this.$emit('removedTag', tag.id);
		},
		removeAll() {
			this.tags.forEach(t => this.removeTag(t));
			this.resetSearchTerm();
		},
		resetSearchTerm() {
			this.setStateValue(["activeSearchTerm", ""]);
		}
	},
};
